import { beginningOfDay, formattedDateForSubscription } from '@talos/kyoko';
import { addDays } from 'date-fns';

export function getReconMismatchesBlotterDefaultStartDate() {
  return formattedDateForSubscription(addDays(beginningOfDay(), -2));
}
